var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { ButtonBase } from '../../core/ButtonBase';
import styles from './LinkAsButton.module.scss';
// TODO: Fix the generics for LinkAsButton to accept OverridableGenericProps of different default element type
var LinkAsButtonComponent = function (_a, ref) {
    var _b = _a.theme, theme = _b === void 0 ? 'primary' : _b, component = _a.component, className = _a.className, _c = _a.small, small = _c === void 0 ? false : _c, props = __rest(_a, ["theme", "component", "className", "small"]);
    var classNames = cx(styles.link, className);
    return (React.createElement(ButtonBase, __assign({ ref: ref, theme: theme, component: component || 'a', className: classNames }, props, { save: false, small: small, success: false, waiting: false })));
};
/**
 * @tdr
 * @tdr-candidates: a
 */
export var LinkAsButton = forwardRef(LinkAsButtonComponent);
//# sourceMappingURL=LinkAsButton.js.map